export default "__VITE_ASSET__w6hpczVX__"